import { motion } from 'motion/react'

interface SetupProgressRingProps {
  percentage: number
  size?: number
  strokeWidth?: number
  showLabel?: boolean
}

export function SetupProgressRing({
  percentage,
  size = 36,
  strokeWidth = 3,
  showLabel = true,
}: SetupProgressRingProps) {
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const center = size / 2

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className="shrink-0 -rotate-90"
    >
      {/* Track */}
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        className="stroke-primary-100"
        strokeWidth={strokeWidth}
      />
      {/* Progress arc */}
      <motion.circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        className="stroke-primary-500"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={circumference}
        initial={{ strokeDashoffset: circumference }}
        animate={{ strokeDashoffset: circumference - (percentage / 100) * circumference }}
        transition={{ type: 'spring', damping: 25, stiffness: 200 }}
      />
      {/* Center label */}
      {showLabel && size >= 32 && (
        <text
          x={center}
          y={center}
          textAnchor="middle"
          dominantBaseline="central"
          className="fill-primary-700 font-medium rotate-90 origin-center"
          style={{ fontSize: size * 0.24 }}
        >
          {percentage}%
        </text>
      )}
    </svg>
  )
}
